import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

function TermsModal({ isOpen, onClose }) {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title marcellus">{t('terms.title')}</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="terms-section">
            <h3 className="section-title marcellus">{t('terms.sections.orderLeadTime.title')}</h3>
            {t('terms.sections.orderLeadTime.paragraphs', { returnObjects: true }).map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="terms-section">
            <h3 className="section-title marcellus">{t('terms.sections.shipping.title')}</h3>
            <p>{t('terms.sections.shipping.paragraphs.0')}</p>
            <p className="font-italic">{t('terms.sections.shipping.paragraphs.1')}</p>
          </div>

          <div className="terms-section">
            <h3 className="section-title marcellus">{t('terms.sections.internationalOrders.title')}</h3>
            <p>{t('terms.sections.internationalOrders.intro')}</p>
            <ul>
              {t('terms.sections.internationalOrders.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="section-title marcellus">{t('terms.sections.returnsExchanges.title')}</h3>
            <p>{t('terms.sections.returnsExchanges.intro')}</p>

            <h4 className="subsection-title marcellus">{t('terms.sections.returnsExchanges.subsections.purchases.title')}</h4>
            <p>{t('terms.sections.returnsExchanges.subsections.purchases.content')}</p>

            <h4 className="subsection-title marcellus">{t('terms.sections.returnsExchanges.subsections.nonReturnableItems.title')}</h4>
            <ul>
              {t('terms.sections.returnsExchanges.subsections.nonReturnableItems.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <p className="font-weight-bold">{t('terms.sections.returnsExchanges.specialNote')}</p>
          </div>

          <div className="terms-section">
            <h3 className="section-title marcellus">{t('terms.sections.repairs.title')}</h3>
            <p>{t('terms.sections.repairs.content')}</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            {t('terms.closeButton')}
          </button>
        </div>
      </div>
    </div>
  )
}

TermsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default TermsModal
